import React, { useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  Col,
  Divider,
  message,
  Row,
  Select,
  Table,
} from 'antd';
import { connect, useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Form } from '@ant-design/compatible';
import {
  getUserGroupsAction,
  saveUserGroupAction,
} from '../../actions/UserActions';
import CustomAddNewPageContent from '../../components/Content/CustomAddNewPageContent';
import checkEnabledFeatures from '../../components/Authorization/Feature';

import '@ant-design/compatible/assets/index.css';

const { Option } = Select;

function findObjectBySelectedKey(list, key) {
  if (list) {
    const selected = list.filter(item => item.id === key);
    if (selected.length === 1) {
      return selected[0];
    }
  }

  return [];
}

const PermissionPage = ({ form }) => {
  const dispatch = useDispatch();

  const [selected, setSelected] = useState(null);

  const { userGroups, currentUser } = useSelector(store => ({
    userGroups: store.userReducer.userGroups,
    currentUser: store.userReducer.currentUser,
  }));

  useEffect(() => {
    dispatch(getUserGroupsAction());
  }, []);

  const handleUserGroupChange = value => {
    if (value === undefined) {
      setSelected(null);
      form.resetFields();
    } else {
      const selectedObj = findObjectBySelectedKey(userGroups, value);
      
      setSelected(selectedObj);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();

    form.validateFields((err, values) => {
      if (!err && selected !== null) {
        
        const dataToSend = {
          id: selected.id,
          value: selected.value,
          permission: {
            item: {
              read: values.item_read,
              write: values.item_write,
            },
            condition: {
              read: values.condition_read,
              write: values.condition_write,
            },
            treatment: {
              read: values.treatment_read,
              write: values.treatment_write,
            },
            movement: {
              read: values.movement_read,
              write: values.movement_write,
            },
            setting: {
              read: values.setting_read,
              write: values.setting_write,
            },
            user: {
              read: values.user_read,
              write: values.user_write,
            },
            appcms: {
              read: values.appcms_read,
              write: values.appcms_write,
            },
            curatorialForm: {
              read: values.curatorialForm_read,
              write: values.curatorialForm_write,
            },
            technicalForm: {
              read: values.technicalForm_read,
              write: values.technicalForm_write,
            },
            insurance: {
              read: values.insurance_read,
              write: values.insurance_write,
            },
          },
        };
        
        // eslint-disable-next-line react/destructuring-assignment
        dispatch(saveUserGroupAction(dataToSend));
        message.success('User Permissions are saved!');
      }
    });
  };

  let rows = [
    {
      key: 'user',
      name: 'User Management',
    },
    {
      key: 'setting',
      name: 'Settings',
    },
  ];

  if (checkEnabledFeatures(currentUser, 'Item-Cataloging')) {
    rows = [
      ...rows,
      {
        key: 'item',
        name: 'Items',
      },
      {
        key: 'condition',
        name: 'Condition Reports',
      },
      {
        key: 'treatment',
        name: 'Treatment Reports',
      },
      {
        key: 'movement',
        name: 'Movement Reports',
      },
      {
        key: 'curatorialForm',
        name: 'Curatorial Form',
      },
      {
        key: 'technicalForm',
        name: 'Technical Form',
      },
      {
        key: 'insurance',
        name: 'Insurance',
      },
    ];
  }

  if (checkEnabledFeatures(currentUser, 'App-Cms')) {
    rows = [
      ...rows,
      {
        key: 'appcms',
        name: 'App CMS',
      },
    ];
  }

  const columns = [
    {
      title: 'Menu items',
      dataIndex: 'name',
      key: 'menuItem',
      align: 'center',
    },
    {
      title: 'Read',
      key: 'read',
      align: 'center',
      render: (text, record) => (
        <div style={{ justifyContent: 'center' }}>
          <Form.Item style={{ justifyContent: 'center' }}>
            {form.getFieldDecorator(record.key + '_read', {
              rules: [],
              valuePropName: 'checked',
              initialValue:
                selected && selected.permission
                  ? selected.permission[record.key].read
                  : false,
            })(<Checkbox />)}
          </Form.Item>
        </div>
      ),
    },
    {
      title: 'Write',
      key: 'write',
      align: 'center',
      render: (text, record) => (
        <div style={{ justifyContent: 'center' }}>
          <Form.Item style={{ justifyContent: 'center' }}>
            {form.getFieldDecorator(record.key + '_write', {
              rules: [],
              valuePropName: 'checked',
              initialValue:
                selected && selected.permission
                  ? selected.permission[record.key].write
                  : false,
            })(<Checkbox />)}
          </Form.Item>
        </div>
      ),
    },
  ];

  return (
    <CustomAddNewPageContent
      title="User Group Permissions"
      subTitle="User Management"
    >
      <Select
        placeholder="Select User Group"
        style={{ width: 256 }}
        allowClear
        showSearch
        filterOption
        optionFilterProp="children"
        onChange={handleUserGroupChange}
      >
        {userGroups.map(item => (
          <Option key={item.id} value={item.id}>
            {item.value}
          </Option>
        ))}
      </Select>
      <Divider />
      <Form onSubmit={handleSubmit}>
        <Row type="flex" justify="center">
          <Col span={16}>
            <Table columns={columns} dataSource={rows} pagination={false} />
          </Col>
        </Row>
        <Row type="flex" justify="center" style={{ marginTop: 30 }}>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Row>
      </Form>
    </CustomAddNewPageContent>
  );
};

PermissionPage.propTypes = {
  // saveUserGroupAction: PropTypes.func,
  // getUserGroupsAction: PropTypes.func,
  form: PropTypes.object,
  // userGroups: PropTypes.array,
};

const WrappedPermissionPage = Form.create({ name: 'permission' })(
  PermissionPage,
);

function mapStateToProps({ userReducer }) {
  const { userGroups } = userReducer;
  return { userGroups };
}

const WiredPermissionPage = connect(mapStateToProps, {
  saveUserGroupAction,
  getUserGroupsAction,
})(WrappedPermissionPage);

export default WiredPermissionPage;
